import { configureStore } from "@reduxjs/toolkit"
import LoginReducer from "@/stores/login_slice"
import ConnStatsReducer from "@/stores/conn_stats_slice"
import MousePosReducer from "@/stores/mouse_slice"
import RemoteDeskStateReducer from "@/stores/remote_desk_state_slice"
import AuthReducer from "@/stores/auth_slice"
import AppReducer from "@/stores/app_slice"
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux"

export const store = configureStore({
  reducer: {
    app: AppReducer,
    // 登录页面所需的状态
    login: LoginReducer,
    // 云桌面连接状态统计
    connStats: ConnStatsReducer,
    // 鼠标位置
    mousePos: MousePosReducer,
    // 云桌面状态(例如是否全屏)
    remoteDeskState: RemoteDeskStateReducer,
    // 全局 auth state
    auth: AuthReducer,
  },
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

export const useAppDispatch: () => AppDispatch = useDispatch
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
